import {
  Grid,
  IconButton,
  Button,
  Input,
  Typography,
  TextField,
  Box,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import { validateWebsite, INPUT_LIMITS } from "../../consts";

import "../style.css";

const EditableFields = ({
  label,
  value,
  onChange,
  textBox,
  handleFormChange,
  fieldName,
  updateField,
}) => {
  const [edit, setEdit] = useState(false);
  const [inputValue, setInputValue] = useState(value);
  const [originalValue, setOriginalValue] = useState(value);
  const [error, setError] = useState("");
  
  useEffect(() => {
    setInputValue(value);
    setOriginalValue(value);
  }, [value]);

  const handleSave = () => {
    if (inputValue === "") {
      setError("Field is Required");
      return;
    }
    
    // Input length validation based on field type
    let maxLength = INPUT_LIMITS.DESCRIPTION; // Default
    if (fieldName === 'url') {
      maxLength = INPUT_LIMITS.URL;
      if (!validateWebsite(inputValue)) {
        setError("Please Enter Correct Website Link, Include prefix (https://, http://)");
        return;
      }
    } else if (fieldName === 'name' || fieldName === 'title') {
      maxLength = INPUT_LIMITS.NAME;
    } else if (textBox) {
      maxLength = INPUT_LIMITS.DESCRIPTION;
    }
    
    if (inputValue.length > maxLength) {
      setError(`Maximum length is ${maxLength} characters`);
      return;
    }
    
    if (inputValue) {
      updateField(fieldName, inputValue);
      setEdit(false);
      setError("");
    }
  };

  const handleCancel = () => {
    setInputValue(originalValue);
    setEdit(false);
    setError("");
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.secondary' }}>
        {label}
      </Typography>
      
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {edit ? (
          <TextField
            value={inputValue}
            onChange={(e) => {
              // Apply length limit based on field type
              let maxLength = INPUT_LIMITS.DESCRIPTION;
              if (fieldName === 'url') {
                maxLength = INPUT_LIMITS.URL;
              } else if (fieldName === 'name' || fieldName === 'title') {
                maxLength = INPUT_LIMITS.NAME;
              } else if (textBox) {
                maxLength = INPUT_LIMITS.DESCRIPTION;
              }
              
              const newValue = e.target.value.slice(0, maxLength);
              setInputValue(newValue);
              handleFormChange({ ...e, target: { ...e.target, value: newValue } });
              setError("");
            }}
            name={fieldName}
            error={!!error}
            helperText={error || `${inputValue.length}/${fieldName === 'url' ? INPUT_LIMITS.URL : fieldName === 'name' || fieldName === 'title' ? INPUT_LIMITS.NAME : INPUT_LIMITS.DESCRIPTION} characters`}
            multiline={textBox ? true : false}
            rows={textBox ? 4 : 1}
            variant="outlined"
            size="small"
            sx={{ flex: 1 }}
            autoFocus
            inputProps={{
              maxLength: fieldName === 'url' ? INPUT_LIMITS.URL : fieldName === 'name' || fieldName === 'title' ? INPUT_LIMITS.NAME : INPUT_LIMITS.DESCRIPTION
            }}
          />
        ) : (
          <Typography 
            variant="body1" 
            sx={{ 
              flex: 1, 
              py: 1, 
              px: 2, 
              backgroundColor: 'grey.50',
              borderRadius: 1,
              minHeight: 40,
              display: 'flex',
              alignItems: 'center'
            }}
          >
            {inputValue || <span style={{ color: '#999' }}>Not set</span>}
          </Typography>
        )}
        
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          {edit ? (
            <>
              <Tooltip title="Save">
                <IconButton 
                  onClick={handleSave}
                  color="primary"
                  size="small"
                >
                  <SaveIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Cancel">
                <IconButton 
                  onClick={handleCancel}
                  size="small"
                >
                  <CancelIcon />
                </IconButton>
              </Tooltip>
            </>
          ) : (
            <Tooltip title="Edit">
              <IconButton 
                onClick={() => setEdit(true)}
                color="primary"
                size="small"
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default EditableFields;
